import PaymentCard from './paymentCard';

export default PaymentCard;
